export const metaDescriptions = (str: string): object[] => {
  return [
    { vmid: 'description', name: 'description', content: str },
    { vmid: 'twitter:description', name: 'twitter:description', content: str },
    { vmid: 'og:description', property: 'og:description', content: str },
  ];
};

export const metaTitles = (str: string): object[] => {
  return [
    { vmid: 'twitter:title', name: 'twitter:title', content: str },
    { vmid: 'og:title', property: 'og:title', content: str },
  ];
};
